// 全局
export default {
	data(){
		return {
			
		}
	},
	mounted(){
     
    },
    watch:{
        "$store.state.hiddenNav"(){
            let page = this.$refs.page
            
            if(page){
                if(this.$store.state.hiddenNav){
                    page.classList.add("hidden-nav-page");
                }else{
                    page.classList.remove("hidden-nav-page");
                }
            }
        }
    },
	created(){
		
	},
}


// WEBPACK FOOTER //
// ./src/vue/mixin/hidden-nav-mixin.js